export default "__VITE_ASSET__CkKoMN3K__"